import {DateTime, Duration} from "luxon";
import {Service, service} from "./di";

@service
export class DateTimeService extends Service {

	getNow (): DateTime {
		return DateTime.local();
	}

	fromJsDate (jsDate: Date): DateTime {
		return DateTime.fromJSDate(jsDate);
	}

	formatDate (date: any, format: string): string {
		return DateTime.fromJSDate(date).toFormat(format);
	}

	setLocale (locale: any): DateTime {
		return DateTime.local().setLocale(locale);
	}

	toISO (date: any): string {
		return DateTime.fromJSDate(date).toISO({suppressMilliseconds: true});
	}

	getDuration (firstDate: any, lastDate: any): Duration {
		return firstDate.diff(DateTime.fromJSDate(lastDate));
	}

	getExactDuration (durationObj: any, unit: any): Duration {
		return durationObj.as(unit);
	}
}
